import React from 'react';
import { Box, Grid, Typography, styled, useMediaQuery } from '@mui/material';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArchiveIcon from '@mui/icons-material/Archive';
import { useLocation } from 'react-router-dom';
const FooterWrapper = styled('footer')(({ theme }) => ({
    // padding: theme.spacing(2),
    backgroundColor: 'transparent',
    textAlign: 'center',
}));

const FooterText = styled(Typography)(({ theme }) => ({
    color: '#626b74',
}));

const Footer = () => {
    const location = useLocation();
    const isTabletAndAbove = useMediaQuery(theme => theme.breakpoints.up('md'));
    return (
        <FooterWrapper
            sx={{
                paddingBottom: !isTabletAndAbove ? '10px' : '0px',
                display: location.pathname === '/' ? 'none' : 'auto',
            }}
        >
            <Grid
                container
                spacing={0}
                directon="row"
                justifyContent="center"
                alignItems="center"
            >
                <Box
                    item
                    xs={12}
                    sx={{ display: !isTabletAndAbove ? '' : 'none' }}
                >
                    <FooterText variant="body1" sx={{}}>
                        &copy; Copyright 2023 airTeachr <br /> All rights
                        reserved
                    </FooterText>
                </Box>
            </Grid>
        </FooterWrapper>
    );
};

export default Footer;
